import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";

const Partners = () => {
  const benefits = [
    "Competitive wholesale pricing",
    "No minimum order quantities",
    "White-label solutions available",
    "Dedicated partner support",
    "Fast turnaround times",
    "Quality guarantee",
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        <div className="bg-gradient-to-r from-amber-600 via-orange-600 to-cyan-600 py-12">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Partner Program
            </h1>
            <p className="text-white/90 text-lg">
              Join our network of successful print-on-demand partners
            </p>
          </div>
        </div>

        <div className="container mx-auto px-4 py-16">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold mb-4">Become a Partner</h2>
              <p className="text-muted-foreground mb-6">
                Partner with AAAprinters to expand your business with our premium print-on-demand services.
                We provide everything you need to succeed in the custom printing industry.
              </p>
              <div className="space-y-3">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <CheckCircle className="text-brand-primary flex-shrink-0" size={20} />
                    <span>{benefit}</span>
                  </div>
                ))}
              </div>
              <Button className="mt-6" size="lg">Apply Now</Button>
            </div>

            <Card>
              <CardHeader>
                <CardTitle>Partner Benefits</CardTitle>
                <CardDescription>What you get as a partner</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div>
                  <h3 className="font-semibold mb-2">💰 Better Margins</h3>
                  <p className="text-sm text-muted-foreground">
                    Access to wholesale pricing that gives you better profit margins
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">🎨 White-Label Options</h3>
                  <p className="text-sm text-muted-foreground">
                    Sell under your own brand with our white-label solutions
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">📦 Drop Shipping</h3>
                  <p className="text-sm text-muted-foreground">
                    We handle fulfillment and shipping directly to your customers
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">🤝 Dedicated Support</h3>
                  <p className="text-sm text-muted-foreground">
                    Direct line to our partner success team
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Partners;
